'use strict';

/**
 * 
 */
module.controller('parameterListCtrl',
        [ '$scope', '$rootScope', '$state', 'alertService', 'parameterService', function($scope, $rootScope, $state, alertService, parameterService) {

            $scope.loading = false;
            $scope.parameterCategory = null;
            $scope.parameterType = {};
            $scope.parameterTypes = [];
            $scope.parameter = {};

            $scope.parameters = [];
            $scope.pagination = {
                current : 1,
                total : 0
            };

            /**
             * Funcion que se ejecuta cuando se selecciona algún elemento del comboBox de
             * cetegorías, se encarga de iniciarlizar el ComboBox de tipos de acuerdo a la
             * categoría seleccionada.
             * @param constantSelected
             */
            $scope.onConstantCategoryChange = function(constantSelected){
                var paramTypes = PARAMETER_TYPE.values();
                var typesfromCategory = [];
                for(var i = 0 ; i < paramTypes.length ; i++){
                	if(constantSelected && constantSelected[0]){
                		if(constantSelected[0].enumName === paramTypes[i].category.enumName ){
                            typesfromCategory.push(paramTypes[i]);
                        }                		
                	}
                }
                $scope.parameterType = {};
                $scope.parameterTypes = typesfromCategory;
            };

            /**
             * Función que se encarga de consultar los parámetros dado un número de página
             * @param page
             */
            $scope.search = function(page) {
                $scope.loading = true;
                page = page == undefined ? 1 : page;

                $scope.pagination.current = page;

                var filter = {};
                filter.offset = (page - 1) * $rootScope.pageSize;
                filter.limit = $rootScope.pageSize;

                if($scope.parameterCategory && $scope.parameterCategory[0]){
                    filter.category = $scope.parameterCategory[0].enumName;
                }

                if($scope.parameterType.selected && $scope.parameterType.selected[0]){
                    filter.type = $scope.parameterType.selected[0].enumName;
                }

                if($scope.parameter.name){
                    filter.name = $scope.parameter.name;
                }

                if($scope.parameter.value){
                    filter.value = $scope.parameter.value;
                }

                parameterService.searchParameters(filter).then(function(response) {
                    $scope.loading = false;

                    var result = response.getData();

                    $scope.parameters = result.results;
                    $scope.pagination.total = result.totalRegisters;
                }, function(response) {
                    $scope.loading = false;
                });
            };

            $scope.clearFilters = function() {
                $scope.parameter = {};
                $scope.parameterCategory = null;
                $scope.parameterType = {};
            };

            /**
             * Por defecto consulta los parámetros de la primera página con los filtros por defecto
             */
            $scope.search(1);

        } ]);
